export const prizeTypes = [
  {
    label: 'IMac Pro',
    value: 'imac',
  },
  {
    label: 'MacBook Pro',
    value: 'macbook',
  },
  {
    label: 'Samsung Galaxy Book2 Pro',
    value: 'samsung_galaxy_book',
  },
  {
    label: 'IPhone 16 Pro Max',
    value: 'iphone_16',
  },
  {
    label: 'Samsung S25 Ultra',
    value: 'samsung_s25',
  },
  {
    label: 'Golden Bar 10g',
    value: 'gold_10',
  },
  {
    label: 'Golden Bar 5g',
    value: 'gold_5',
  },
  {
    label: 'Samsung Galaxy Watch',
    value: 'samsung_galaxy_watch',
  },
  {
    label: 'Apple Watch',
    value: 'apple_watch',
  },
  {
    label: 'AirPods',
    value: 'air_pods',
  },
  {
    label: 'Headway Gift Boxes',
    value: 'hw_gift_box',
  },
  {
    label: '10 Giftshop Crowns',
    value: 'giftshop_crowns_10',
  },
  {
    label: '5 USD',
    value: 'usd_5',
  },
]
